export default /*@ngInject*/ function (flowFactoryProvider) {
    flowFactoryProvider.factory = function (opts) {
        var Flow = require('@flowjs/ng-flow/dist/ng-flow-standalone.js'); 
        return new Flow(opts);
    };
}